import React, { Component } from 'react';
import { Search, Image } from 'semantic-ui-react';

export default class GeneralSearch extends React.Component {
	
	constructor(props) {
		
		super(props);
		
		this.state = {
			minCharacters: 2,
			focused: false
		};
		
		this.callbackRequest = this.callbackRequest.bind(this);
		this.handleSearchChange = this.handleSearchChange.bind(this);
		this.search = this.search.bind(this);
		this.onFocus = this.onFocus.bind(this);
		this.onBlur = this.onBlur.bind(this);
	}
	
	componentWillMount() {
		
		this.resetComponent()
	}
	
	componentDidMount() {
		
		window["GeneralSearchCallbackRequest"] = (response) => {
			
			this.callbackRequest(response);
		};
	}
	
	onFocus = () => this.setState({ focused: true });
	
	onBlur = () => this.setState({ focused: false });
	
	resetComponent = () => this.setState({ isLoading: false, results: [], value: '' });
	
	handleResultSelect = (e, { result }) => {
		
		if (!document.getElementById("loading-screen"))
		{
			this.setState({ value: result.title });
		}
		else
		{
			selected.showing_car = false;
			selected.date = false;
			selected.km = false;
			
			history.pushState({ code: result.code }, null, "/code/" + result.code);
		}
		
		e.target.blur();
	};
	
	handleSearchChange(e, { value }) {
		
		if (value.length >= this.state.minCharacters)
		{
			this.setState({ value, aboutToSearch: true });
			
			this.search(value);
		}
		else
		{
			this.setState({ value, aboutToSearch: false });
		}
	}
	
	search = _.debounce(value => {
		
		this.setState({ isLoading: true });
		
		if (typeof GeneralSearchRequest === "function")
		{
			GeneralSearchRequest(value);
		}
		else
		{
			setTimeout(() => {
				
				this.callbackRequest({data: { results: {
					"code": {
						name: "code",
						results: [
							{
								"make": "Dodge",
								"type": "Caliber 1.8i 16v S",
								"hp": "150",
								"code": "38948",
								"image": "http://root.localhost/assembler/export/public_html/make_logo/dodge.png"
							}
						]
					},
					"plate": {
						name: "plate",
						results: [
							{
								"make": "Dodge",
								"type": "Caliber 1.8i 16v SE",
								"hp": "150",
								"code": "38949",
								"image": "http://root.localhost/assembler/export/public_html/make_logo/dodge.png"
							}
						]
					}
				}}});
				
			}, 300);
		}
	}, 500);
	
	// (make + " " + type + " " + hp + "hp")
	
	callbackRequest(response) {
		
		if (this.state.value.length < 1) return this.resetComponent();
		
		var results = [];
		
		if (response.data.results)
		{
			const item = (obj) => ({
				title: obj.code/*(obj.make + " " + obj.type + " " + obj.hp + "hp")*/, ...obj
			});
			
			results = response.data.results;
			
			for (const index in results)
			{
				for (var i = 0; i < results[index].results.length; i++)
				{
					results[index].results[i] = item(results[index].results[i]);
				}
			}
		}
		
		this.setState({ isLoading: false, aboutToSearch: false, results });
	}
	
	render() {
		
		const { minCharacters, isLoading, value, results, focused, aboutToSearch } = this.state;
		
		const { onFocus, onBlur, handleResultSelect, handleSearchChange } = this;
		
		const renderer = ({ image, hp, make, title, type, code }) => [
			image && (
				<div key='image' className='image'>
					<Image src={image} size='small' />
				</div>
			),
			<div key='content' className='content'>
				{hp && <div className='price'>{hp}hp</div>}
				{make && <div className='title'>{make}</div>}
				{type && <div className='description'>{type}</div>}
				{code && <div className='description'>#{code}</div>}
			</div>,
		];
		
		return (
			<Search
				fluid
				category
				size="small"
				placeholder={text.generalSearch}
				/*minCharacters={this.state.minCharacters}*/
				noResultsMessage={isLoading ? text.loadingText + "..." : text.noResults}
				/*open={!(!isLoading && aboutToSearch) && value.length >= minCharacters && focused}
				onFocus={onFocus}
				onBlur={onBlur}*/
				loading={isLoading}
				selectFirstResult={true}
				onResultSelect={handleResultSelect}
				onSearchChange={handleSearchChange}
				resultRenderer={renderer}
				results={!isLoading ? results : []}
				value={value}
				{...this.props}
			/>
		)
	}
}